let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("78hg5")).then(() => parcelRequire('h1Nzj'));